<bom-error [statusCode]="404"></bom-error>